<template>
  <main>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 top-wrapper">
          <TopTemplate>
            <template v-slot:left-element>
              <router-link
                :to="{ name: 'ClasseList' }"
                class="btn btn-outline-primary button"
                :disabled="loading"
              >
                <i class="arrow left"></i>
                Retour
              </router-link>
            </template>

            <template v-slot:right-element>
              <div class="d-flex buttons-wrapper">
                <router-link
                  :to="{ name: 'ClasseList' }"
                  class="btn btn-outline-primary button"
                  :disabled="loading"
                >
                  <i class="icon-trash"></i>
                  Supprimer
                </router-link>
                <router-link
                  :to="{ name: 'AjoutDm' }"
                  class="btn button btn-primary"
                  :disabled="loading"
                >
                  <i class="icon-edit-03"></i>
                  Modifier
                </router-link>
              </div>
            </template>
          </TopTemplate>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="coor-wrapper">
            <div class="part-left">
              <div class="avatar"></div>
              <div class="name-wrapper">
                <h3>COOPER <span>Philips</span></h3>
                <span>Né le 22/06/2010, à Tunis</span>
              </div>
            </div>

            <div class="part-right">
              <span>niveau</span>
              <span>1ère B1</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-6 top-part">
          <div class="part">
            <h4 class="custom-title">Parents : Père</h4>
            <div class="detail-wrapper">
              <label>Prénom du père : </label>
              <p>COOPER</p>
            </div>
            <div class="detail-wrapper">
              <label>Nom du père :</label>
              <p>Philips</p>
            </div>
            <div class="detail-wrapper">
              <label>Fonction du père :</label>
              <p>Médecin</p>
            </div>
            <div class="detail-wrapper">
              <label>Lieu du travail : </label>
              <p>Tunisie</p>
            </div>
            <div class="detail-wrapper">
              <label>Adresse email : </label>
              <p>exemple@gmail.com</p>
            </div>
            <div class="detail-wrapper">
              <label>Adresse :</label>
              <p>Cité Riyadh, Sousse</p>
            </div>
            <div class="detail-wrapper">
              <label>Ville :</label>
              <p>Sousse</p>
            </div>
            <div class="detail-wrapper">
              <label>Code postale : </label>
              <p>5000Sousse</p>
            </div>
            <div class="detail-wrapper">
              <label>Pays :</label>
              <p>Tunisie</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-6 top-part">
          <div class="part">
            <h4>Parents : Mère</h4>
            <div class="detail-wrapper">
              <label>Prénom du père : </label>
              <p>COOPER</p>
            </div>
            <div class="detail-wrapper">
              <label>Nom du père :</label>
              <p>Philips</p>
            </div>
            <div class="detail-wrapper">
              <label>Fonction du père :</label>
              <p>Médecin</p>
            </div>
            <div class="detail-wrapper">
              <label>Lieu du travail : </label>
              <p>Tunisie</p>
            </div>
            <div class="detail-wrapper">
              <label>Adresse email : </label>
              <p>exemple@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper-bande">
        <div class="row g-0"  >
        <div class="col-md-12  ">
          <h4 class="custom-title">situation familiale</h4>
        </div>
        <div class="col-md-6">
          <div class="detail-wrapper">
              <label>Situation de l’enfant :</label>
              <p>Habite avec ses parents</p>
            </div>
        </div>
        <div class="col-md-6">
          <div class="detail-wrapper">
              <label>Situation des parents :</label>
              <p>Habite avec ses parents</p>
            </div>
        </div>
        </div>
      </div>

  <div class="wrapper-bande">
        <div class="row g-0"  >
        <div class="col-md-12  ">
          <h4 class="custom-title">scolarité</h4>
        </div>
        <div class="col-md-4">
          <div class="detail-wrapper">
              <label>Niveau :</label>
              <p>1ère année</p>
            </div>
        </div>
        <div class="col-md-4">
          <div class="detail-wrapper">
              <label>Année scolaire :</label>
              <p>2020 - 2021</p>
            </div>
        </div>
        <div class="col-md-4">
          <div class="detail-wrapper">
              <label>École :</label>
              <p>Le petit Archimède</p>
            </div>
        </div>
        </div>
      </div>

 <div class="wrapper-bande">
        <div class="row g-0"  >
        <div class="col-md-12  ">
          <h4 class="custom-title">activités extrascolaires</h4>
        </div>
        <div class="col-md-6">
          <div class="detail-wrapper">
              <label class="spec-label" >Activité :</label>
              <p>Musique</p>
            </div>
        </div>
        <div class="col-md-6">
          <div class="detail-wrapper">
              <label class="spec-label" >Préciser : </label>
              <p> Piano</p>
            </div>
        </div>
        </div>
      </div>


   

    </div>
  </main>
</template>




<script>
import TopTemplate from "../components/toptemplate/TopTemplate.vue";
import buttonElement from "../components/buttons/Button.vue";
import SimpleSelect from "../components/selects/SimpleSelect.vue";
import MultipleSelect from "../components/selects/MultipleSelect.vue";

export default {
  name: "AjoutTuteur",
  components: {
    TopTemplate,
    buttonElement,
    SimpleSelect,
    MultipleSelect,
    test: false,
  },
};
</script>

